'use strict';
import './mobile-marketing.scss';
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button, Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MarketingCarousel from '../../../../../../shared/components/pop-up/marketing-modal/marketing-carousel';
import { getMarketingContent } from 'app/modules/cms/service/store/cms-selectors';
import { DisplayMode } from 'app/modules/cms/model/marketing-campaign-models';
import { hidePageMarketing } from 'app/modules/corporate/service/corporate.service';

const MobileMarketing = () => {

  const marketingDisplay = useSelector(getMarketingContent(DisplayMode.INFO_POP_IN));

  const dispatch = useDispatch();

  const comeBack = () => {
    dispatch(hidePageMarketing());
  }

  return (
    <div className="insuredOfferWrapper">
      <Row className="marketingHeader">
        <Col xs="2">
          <div className="navigationMobileBtnFlexBox">
            <Button className="stepButton" onClick={() => comeBack()} >
              <span id="previousStepButton">
                <FontAwesomeIcon icon="chevron-left" />
              </span>
            </Button>
          </div>
        </Col>
        <Col xs="10">
          <span>Nos engagements</span>
        </Col>
      </Row>
      <MarketingCarousel marketingDisplay={marketingDisplay}/>
    </div>
  );
}

export default MobileMarketing;
